export default __webpack_public_path__ + "static/media/ConjuntoBomba.448433e2.svg";